import { Workbook } from 'exceljs'
import * as fs from 'file-saver'
export function exportExcel(header, data, { nameFile = 'FILE', nameSheet = 'Danh sách', nameTable = '' }) {
    return new Promise((resolve, reject) => {
        try {
            // TAB Dữ liệu import ===================
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet(nameSheet)
            worksheet.properties.defaultColWidth = 22
            // add column headers
            worksheet.columns = header.map((e) => {
                return {
                    ...e,
                    header: e.header
                }
            })
            let rowTable = 1
            if (nameTable) {
                const arrayTitle = []
                if (nameTable.includes('\n')) {
                    nameTable.split('\n').forEach((e) => {
                        arrayTitle.push({ text: e.toString() }, { break: true })
                    })
                }
                const headerRow = worksheet.getRow(rowTable)
                headerRow.height = 28
                headerRow.getCell(1).value = arrayTitle.length ? arrayTitle : nameTable
                headerRow.getCell(1).style = { font: { bold: true, size: 24 }, alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }}
                worksheet.mergeCells(rowTable, 1, rowTable, header.length)
                rowTable++
                worksheet.getRow(rowTable).values = header.map((e) => e.header)
            }
            data.forEach((e) => {
                worksheet.addRow(e)
            })
            worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
                row.eachCell((cell) => {
                    if (rowNumber <= rowTable) {
                        row.font = { bold: true }
                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        }
                        for (let i = 1; i <= header.length; i++) {
                            row.getCell(i).fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'e6e6e6' }
                            }
                            row.getCell(i).border = {
                                top: { style: 'thin' },
                                left: { style: 'thin' },
                                bottom: { style: 'thin' },
                                right: { style: 'thin' }
                            }
                        }
                    }
                })
            })

            // Generate Excel File with given name
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                })
                fs.saveAs(blob, nameFile + '.xlsx')
            })
            resolve(true)
        } catch (error) {
            reject(error)
        }
    })
}

export function exportExcelV2(
    dataHeader,
    data,
    {
        nameFile = 'FILE',
        nameSheet = 'Danh sách',
        nameTable = '',
        headerTable = [],
        footerTable = [],
        dataCount = {}
    }
) {
    return new Promise((resolve, reject) => {
        try {
            // TAB Dữ liệu import ===================
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet(nameSheet)
            worksheet.properties.defaultColWidth = 22
            // add column headers
            const [header, col_type_percent] =
                renderDataColumnToHeaderExcel(dataHeader)
            worksheet.columns = header
            let rowTable = 1
            if (nameTable) {
                const arrayTitle = []
                if (nameTable.includes('\n')) {
                    nameTable.split('\n').forEach((e) => {
                        arrayTitle.push({ text: e.toString() }, { break: true })
                    })
                }
                const headerRow = worksheet.getRow(rowTable)
                headerRow.height = 28
                headerRow.getCell(1).value = arrayTitle.length ? arrayTitle : nameTable
                headerRow.getCell(1).style = {
                    font: { bold: true, size: 24 },
                    alignment: {
                        vertical: 'middle',
                        horizontal: 'center',
                        wrapText: true
                    }
                }
                worksheet.mergeCells(rowTable, 1, rowTable, header.length)
                rowTable++
                worksheet.getRow(rowTable).values = header.map((e) =>
                    e.header
                )
            }
            if (headerTable && headerTable.length) {
                headerTable.forEach(({ label, value }) => {
                    const headerRow = worksheet.getRow(rowTable)
                    headerRow.height = 20
                    headerRow.getCell(1).value = `${label}: ${value || ''}`
                    headerRow.getCell(1).style = {
                        font: { bold: true, size: 24 },
                        alignment: { vertical: 'middle', horizontal: 'center' }
                    }
                    worksheet.mergeCells(rowTable, 1, rowTable, header.length)
                    rowTable++
                })
                worksheet.getRow(rowTable).values = header.map((e) =>
                    e.header
                )
            }
            if (JSON.stringify(dataHeader).includes('children')) {
                handleMergeCellHeader(worksheet, rowTable, header)
                rowTable++
            }
            if (col_type_percent.length) {
                data.forEach((e) => {
                    col_type_percent.forEach((el) => {
                        e[el] = e[el] && e[el] / 100
                    })
                })
            }
            if (JSON.stringify(dataHeader).includes('key_data_children')) {
                handleMergeCellContent(worksheet, dataHeader, data, rowTable)
            } else {
                data.forEach((e) => {
                   let row = worksheet.addRow(e)
                    if(e.style){
                        row.eachCell(cell=>{
                            cell.style  = {
                                ...e.style
                            }
                        })
                    }
                })
            }
            if (dataCount) {
                worksheet.addRow(dataCount)
                worksheet.lastRow.font = { bold: true }
            }
            if (footerTable && footerTable.length) {
                let rowTableFooter = data.length + rowTable;
                footerTable.forEach(({ label, value }) => {
                    const headerRow = worksheet.getRow(rowTableFooter)
                    headerRow.height = 20
                    headerRow.getCell(1).value = `${label}: ${value || ''}`
                    headerRow.getCell(1).style = {
                        font: {bold: true},
                        alignment: { vertical: 'middle', horizontal: 'center' }
                    }
                    worksheet.mergeCells(rowTableFooter, 1, rowTableFooter, header.length)
                    headerRow.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'e6e6e6' }
                    };
                    rowTableFooter++
                })
            }
            worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
                row.eachCell((cell) => {
                    if (rowNumber <= rowTable) {
                        row.font = { bold: true }
                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        }
                        for (let i = 1; i <= header.length; i++) {
                            row.getCell(i).fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'e6e6e6' }
                            }
                            row.getCell(i).border = {
                                top: { style: 'thin' },
                                left: { style: 'thin' },
                                bottom: { style: 'thin' },
                                right: { style: 'thin' }
                            }
                        }
                    }
                })
            })

            // Generate Excel File with given name
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                })
                fs.saveAs(blob, nameFile + '.xlsx')
            })
            resolve(true)
        } catch (error) {
            reject(error)
        }
    })
}

function renderDataColumnToHeaderExcel(dataHeaders) {
    const headers = []
    const col_type_percent = []
    for (let i = 0; i < dataHeaders.length; i++) {
        const element = dataHeaders[i]
        const header = []
        if (element.children) {
            for (let j = 0; j < element.children.length; j++) {
                const ele = element.children[j]
                header.push({
                    header: ele.header,
                    key: ele.key,
                    main_key: element.key,
                    main_header: element.header,
                    width: ele.width || 22
                })
            }
            if (header.length === 0) {
                continue
            }
        } else {
            header.push({
                header: element.header,
                key: element.key,
                width: element.width || 22
            })
        }
        headers.push(...header)
    }
    return [headers, col_type_percent]
}

function handleMergeCellHeader(worksheet, rowTable, headers) {
    worksheet.duplicateRow(rowTable, 1, true)
    const headerRow = worksheet.getRow(rowTable)
    const headersDefault = deepCopy(headers)
    headersDefault.forEach((el, index) => {
        if (el.main_key && !el.status) {
            const listIndex = headersDefault
                .map((ele, index) => {
                    if (ele.main_key === el.main_key) {
                        ele.status = true
                        return index
                    }
                })
                .filter((ele) => ele !== undefined)
            const indexFirstMain = listIndex[0]
            const indexLastMain = listIndex.pop()
            headerRow.getCell(indexFirstMain + 1).value = el.main_header
            worksheet.mergeCells(
                rowTable,
                indexFirstMain + 1,
                rowTable,
                indexLastMain + 1
            )
        } else if (!el.main_key) {
            worksheet.mergeCells(rowTable, index + 1, rowTable + 1, index + 1)
        }
    })
}

function handleMergeCellContent(worksheet, header, data, rowTable) {
    let count_header = 0
    const list_col_merge_row = []
    let key_data_children = ''
    let index_row = rowTable + 1
    header.forEach((el) => {
        if (el.children) {
            count_header += el.children.length
        } else {
            count_header += 1
        }
        if (el.key_data_children) {
            key_data_children = el.key_data_children
        } else {
            list_col_merge_row.push(count_header)
        }
    })
    if (key_data_children) {
        data.forEach((el) => {
            if (el[key_data_children] && el[key_data_children].length) {
                el[key_data_children].forEach((ele) => {
                    worksheet.addRow({
                        ...el,
                        ...ele
                    })
                })
                list_col_merge_row.forEach((ele) => {
                    worksheet.mergeCells(
                        index_row,
                        ele,
                        index_row + el[key_data_children].length,
                        ele
                    )
                })
            }
            index_row += (el[key_data_children] && el[key_data_children].length) || 1
        })
    }
}

export function deepCopy(obj) {
    if (Object.prototype.toString.call(obj) === '[object Array]') {
        return obj.map((e) => ({ ...e }))
    }
    return obj
}